<script>
  export let size = 300;
  export let bgColor = 'rgb(64,103,204)';
  export let fgColor = 'orange';
  export let countData;

  $: viewBox = `0 0 ${size} ${size}`;

  $: percent = countData.guestUserCount / countData.totalUserCount;

  $: radius = size / 2;
  $: halfCircumference = Math.PI * radius;
  $: pieSize = halfCircumference * percent;
  $: dashArray = `0 ${halfCircumference - pieSize} ${pieSize}`;
</script>

<div class="chart-container">
  <svg width={size} height={size} {viewBox}>
    <circle r={radius} cx={radius} cy={radius} fill={bgColor} />
    <circle
      r={radius / 2}
      cx={radius}
      cy={radius}
      fill={bgColor}
      stroke={fgColor}
      stroke-width={radius}
      stroke-dasharray={dashArray}
    />
  </svg>
  <div class="info-container">
    <div class="counts-container">
      <p style="background-color: {fgColor};">
        Guest User Count : {countData.guestUserCount}
      </p>
      <p style="background-color: {bgColor};">
        Registered User Count : {countData.totalUserCount - countData.guestUserCount}
      </p>
    </div>
    <p style="background-color: blue;">
      Total User Count : {countData.totalUserCount}
    </p>
  </div>
</div>

<style lang="scss">
  .chart-container {
    text-align: center;
    padding-top: 65px;
    .info-container {
      justify-content: center;
      .counts-container {
        display: flex;
        p {
          width: 100%;
        }
      }
      p {
        color: white;
        margin: 5px;
        padding: 2px 5px;
        border-radius: 5px;
      }
    }
  }
</style>
